import { defineStore } from 'pinia';
import { ref } from 'vue';

// Cross-page handoff for the agent-driven `rdrive_switch_view` frontend tool.
// The RPilot page the agent is leaving stores the target view + selection here
// before router.push; the destination RPilot page consumes it on mount to skip
// its chooser and land directly in the chat view, where the shared RPilotChat
// session (persist-session) carries the conversation on seamlessly.
export const useRPilotStore = defineStore('rpilot', () => {
  // { view: 'schedules'|'task-set-profiles', mode: 'create'|'update'|null,
  //   scheduleId: string|null, taskSetProfileId: string|null }
  const pendingHandoff = ref(null);

  function setHandoff(handoff) {
    pendingHandoff.value = handoff;
  }

  /**
   * Consume the pending handoff if it targets `view`; null otherwise. One-shot
   * so a later manual visit to the same page starts at its chooser as normal.
   */
  function takeHandoff(view) {
    const handoff = pendingHandoff.value;
    if (!handoff || handoff.view !== view) return null;
    pendingHandoff.value = null;
    return handoff;
  }

  return { pendingHandoff, setHandoff, takeHandoff };
});
